<template>
    <div class="playerCreation">
        <p class="name">{{ name }}<span class="cursor">_</span></p>
        <div class="keyboard">
            <div class="row toprow">
                <span 
                    v-for="key in keyboard.toprow" @click="keyPress(key)" class="key" v-bind:class="{ uppercase: useUppercase != 'no', grey: charLimit }">{{ key }}</span>
            </div>
            <div class="row middlerow">
                <span v-for="key in keyboard.middlerow" @click="keyPress(key)" class="key" v-bind:class="{ uppercase: useUppercase != 'no', grey: charLimit }">{{ key }}</span>
            </div>
            <div class="row bottomrow">
                <span class="key shiftkey" @click="keyPress('shift')" v-bind:class="{ green: useUppercase == 'once', red: useUppercase == 'always' }">&uarr;</span>
                <span v-for="key in keyboard.bottomrow" class="key" @click="keyPress(key)" v-bind:class="{ uppercase: useUppercase != 'no', grey: charLimit }">{{ key }}</span>
                <span class="key backspacekey" @click="keyPress('backspace')">&larr;</span>
            </div>
            <div class="row bottomestrow">
                <span class="key spacekey" @click="keyPress(' ')" v-bind:class="{ grey: charLimit }"></span>
            </div>
        </div>
        <div class="okbutton" @click="submitName()">
            <font-awesome-icon icon="check" />
        </div>
    </div>

    

</template>

<script>

import axios from 'axios'

export default {

    name: 'PlayerSelection',

    data() {
        return {
            keyboard: {
                toprow: ['q', 'w', 'e', 'r', 't', 'y', 'u', 'i', 'o', 'p'],
                middlerow: ['a', 's', 'd', 'f', 'g', 'h', 'j', 'k', 'l'],
                bottomrow: ['z', 'x', 'c', 'v', 'b', 'n', 'm'],
            },
            useUppercase: 'once',
            name: '',
            players: []
        }
    },
    
    computed: {
        charLimit() {
            return this.name.length >= 12;
        }
    },

    methods: {
        keyPress(key) {
            if (key == 'shift') {
                this.toggleShift();
            } else if (key == 'backspace') {
                this.name = this.name.slice(0, this.name.length - 1);
            } else {
                if (this.name.length < 12) {
                    if (this.useUppercase == 'once' || this.useUppercase == 'always') {
                        key = key.toUpperCase();
                        if (this.useUppercase == 'once') {
                            this.useUppercase = 'no';
                        }
                    }
                    this.name += key;
                }
            }

            if (key == " " && this.useUppercase != 'always') {
                this.toggleShift();
            }
        },

        toggleShift() {
            if (this.useUppercase == 'no') {
                this.useUppercase = 'once';
            } else if (this.useUppercase == 'once') {
                this.useUppercase = 'always';
            } else if (this.useUppercase == 'always') {
                this.useUppercase = 'no';
            }
        },

        submitName() {
            if (this.name.length > 0 && this.players.indexOf(this.name) == -1) {
                let self = this;
                const params = new URLSearchParams();
                params.append('name', this.name);
                axios.post('/darts_db/users/create_user.php', params).then(function (response) {
                    console.log(response);
                    self.$emit('player-created');
                    self.$root.$emit('reload-players');
                }).catch(function (error) {
                    console.log(error);
                });
            }
            
        },
        loadUsers() {
            const params = {
                params: {
                    // user_id: '1'
                }
            }

            const self = this;
            axios.get('/darts_db/users/get_all_users.php', params).then(function (response) {
                console.log(response);

                for (let i = 0; i < response.data.length; i++) {
                    self.players.push(response.data[i].name);

                }
            }).catch(function (error) {
                console.log(error);
            });
        }

    },

    mounted() {
        this.loadUsers();
    }

}
</script>


<style scoped>

    

    * {
    
        box-sizing: border-box;
    }

    .playerCreation {
        position: absolute;
        width: 800px;
        height: 390px;
        top: 90px;
        /*background: rgba(0,0,0,0.7);*/
        background: #eee;
        z-index: 11;
        /*color: white;*/
        /*display: relative;*/

    }

    .name {
        font-size: 32px;
        text-align: center;
        width: 400px;
        border: 1px solid #ccc;
        margin: 20px auto;
        padding: 5px 5px 10px;
        background: #fff;
        height: 60px;
        /*box-shadow: 1px 1px 3px rgba(0,0,0,0.24);*/
    }

    .cursor {
        color: #222;
    }

    .keyboard {
        position: absolute;
        bottom: 0px;
        /*display: flex;*/
        /*flex-wrap: wrap;*/
        text-align: center;
        width: 100%;
    }

    .row {
        /*height: 100px;*/
        margin-bottom: 10px;
    }

    .key {
        display: inline-block;
        /*border: 1px solid #ccc;*/
        border-top: 1px solid rgba(0,0,0,0.12);
        border-left: 1px solid rgba(0,0,0,0.12);

        font-size: 28px;
        padding: 8px 0px 0;
        width: 60px;
        height: 60px;
        text-align: center;
        box-shadow: 1px 1px 3px rgba(0,0,0,0.48);
        margin-left: 10px;
        border-radius: 10px;
        cursor: pointer;
        user-select: none;
        background: #fff;


    }
    .toprow {

    }
    .middlerow {
        /*margin-left: 30px;*/
    }
    .bottomrow {
        /*margin-left: -60px;*/
    }
    .bottomestrow {
        /*margin-left: 210px;*/
    }
    .key.spacekey {
        width: 340px;
        /*margin-left: 200px;*/
    }

    .key.shiftkey {
        width: 100px;
    }
    .key.backspacekey {
        width: 100px;
    }

    .okbutton {
        position: absolute;
        /*right: 15px;*/
        right: 90px;
        /*bottom: 15px;*/
        bottom: 310px;
        display: inline-block;
        border: 1px solid #ccc;
        font-size: 28px;
        padding: 8px 0px 0;
        width: 100px;
        height: 60px;
        text-align: center;
        box-shadow: 1px 1px 3px rgba(0,0,0,0.24);
        margin-left: 10px;
        border-radius: 10px;
        background: #fff;
        cursor: pointer;
        user-select: none;

    }

    .uppercase {
        text-transform: uppercase;
    }

    .green {
        background: #efe;
        border: 1px solid #0f0;
    }
    .red {
        background: #fee;
        border: 1px solid #f00;
    }

    .grey {
        background: #eee;
        /*border: 1px solid #aaa;*/
    }
</style>
